/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * Exportní typ položky.
 * @export
 * @enum {string}
 */

export const LegendItemTypeE = {
    POINT: 'point',
    LINE: 'line',
    POLYGON: 'polygon',
    IMAGE: 'image'
} as const;

export type LegendItemTypeE = typeof LegendItemTypeE[keyof typeof LegendItemTypeE];



